<!--      主页        -->

<template>
  <div id="home">
    <div class="above-con">
      <!-- weather and params -->
      <el-row :gutter="12">
        <el-col :span="5">
          <div class="grid-content-parameter border-img">
            <img src="../../assets/img/index/left_line.png" alt="border-l" />
            <img src="../../assets/img/index/right_line.png" alt="border-r" />
            <div class="weather">
              <span class="update-time">更新时间: {{weather.time ? weather.time : '今早9：00更新'}}</span>
              <p>
                <span class="weather-logo">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-duoyun" />
                  </svg>
                </span>
                <span class="weather-tem">
                  <i v-if="weather.temperature === ''" class="el-icon-loading"></i>
                  <i v-if="weather.temperature !== ''">
                    <i class="tem-num">{{weather.temperature ? weather.temperature : '加载中...'}}</i>℃
                  </i>
                </span>
              </p>
              <div>
                空气质量：
                <span id="air_quality">{{weather.air ? weather.air : '加载中...'}}</span>
              </div>
              <div class="weather-wind">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-fengkong" />
                </svg>
                <span id="w_wind">{{weather.level ? weather.level : '加载中...'}}</span>
              </div>
              <div class="weather-humidity">
                <svg class="icon" aria-hidden="true">
                  <use xlink:href="#icon-shuixi" />
                </svg>
                <span class="humidity">{{weather.humidity ? weather.humidity : '湿度 加载中...'}}</span>
              </div>
            </div>
            <div class="some-params">
              <ul>
                <li @click="toggleShow(0)" title="点击以查看更多信息">
                  <div class="average-tem" v-show="params_visible[0]">
                    <i>室内温度</i>
                    <span>
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-thermometer_icon" />
                      </svg>
                      <i>{{monitor_params.average.temperature}}℃</i>
                    </span>
                  </div>
                  <div class="area-tem" v-show="!params_visible[0]">
                    <p>
                      -1F:
                      <i>{{monitor_params.f_1.temperature}}</i> ℃
                    </p>
                    <p>
                      1F:
                      <i>{{monitor_params.f1.temperature}}</i> ℃
                    </p>
                  </div>
                </li>
                <li>
                  <i>室外温度</i>
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-thermometer_icon" />
                    </svg>
                    <i>{{monitor_params.temperature}}℃</i>
                  </span>
                </li>
                <li @click="toggleShow(1)" title="点击以查看更多信息">
                  <div class="average-hum" v-show="params_visible[1]">
                    <i>室内湿度</i>
                    <span>
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-kongqishidu" />
                      </svg>
                      <i>{{monitor_params.average.humidity}}</i>
                    </span>
                  </div>
                  <div class="area-tem" v-show="!params_visible[1]">
                    <p>
                      -1F:
                      <i>{{monitor_params.f_1.humidity}}%</i>
                    </p>
                    <p>
                      1F:
                      <i>{{monitor_params.f1.humidity}}%</i>
                    </p>
                  </div>
                </li>
                <li>
                  <i>室外湿度</i>
                  <span>
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#icon-kongqishidu" />
                    </svg>
                    <i>{{monitor_params.humidity}}</i>
                  </span>
                </li>
                <li @click="toggleShow(2)" title="点击以查看更多信息">
                  <div class="average-pm25" v-show="params_visible[2]">
                    <i>PM2.5</i>
                    <span>
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-icon-pm" />
                      </svg>
                      <i>{{monitor_params.average.pm25}}</i>
                    </span>
                  </div>
                  <div class="area-tem" v-show="!params_visible[2]">
                    <p>
                      -1F:
                      <i>{{monitor_params.f_1.pm25}}</i>
                    </p>
                    <p>
                      1F:
                      <i>{{monitor_params.f1.pm25}}</i>
                    </p>
                  </div>
                </li>
                <li @click="toggleShow(3)" title="点击以查看更多信息">
                  <div class="average-co2" v-show="params_visible[3]">
                    <i>CO2浓度</i>
                    <span>
                      <svg class="icon" aria-hidden="true">
                        <use xlink:href="#icon-icon-co" />
                      </svg>
                      <i>{{monitor_params.average.co2}}ppm</i>
                    </span>
                  </div>
                  <div class="area-tem" v-show="!params_visible[3]">
                    <p>
                      -1F:
                      <i>{{monitor_params.f_1.co2}}ppm</i>
                    </p>
                    <p>
                      1F:
                      <i>{{monitor_params.f1.co2}}ppm</i>
                    </p>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
        <el-col :span="10">
          <div class="grid-content-consumptionValue">
            <div class="total-consumption border-img">
              <img src="../../assets/img/index/left_line.png" alt="border-l" />
              <img src="../../assets/img/index/right_line.png" alt="border-r" />
              <h4>系统总能耗</h4>
              <div id="total-chart"></div>
            </div>
            <div class="thermal-val border-img">
              <img src="../../assets/img/index/left_line.png" alt="border-l" />
              <img src="../../assets/img/index/right_line.png" alt="border-r" />
              <h4>近{{weather_error ? '一周' : '24小时'}}温湿度及楼层热力图</h4>
              <div id="tem-hum-chart"></div>
              <div id="floor-thermal">
                <el-dialog
                  style="background-color: rgba(0,0,0,.3) !important;"
                  :title="floors+'F'"
                  :visible.sync="floorViewVisible"
                  width="60%"
                  center
                >
                  <div class="floor-view">
                    <floors :floors="floors" />
                  </div>
                  <span slot="footer" class="dialog-footer">
                    <el-button @click="floorViewVisible = false">退 出</el-button>
                  </span>
                </el-dialog>
                <ul>
                  <li @click="showFloor(-1)">
                    <span>-1</span>
                  </li>
                  <li @click="showFloor(1)">
                    <span>1</span>
                  </li>
                  <li @click="showFloor(2)">
                    <span>2</span>
                  </li>
                  <li @click="showFloor(3)">
                    <span>3</span>
                  </li>
                  <li @click="showFloor(4)">
                    <span>4</span>
                  </li>
                  <li @click="showFloor(5)">
                    <span>5</span>
                  </li>
                  <li @click="showFloor(7)">
                    <span>7</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content-alarmData">
            <div class="block-alarms border-img">
              <img src="../../assets/img/index/left_line.png" alt="border-l" />
              <img src="../../assets/img/index/right_line.png" alt="border-r" />
              <h3>
                <router-link :to="{ name: 'alarmInfo'}">
                  <span>
                    <img src="../../assets/img/index/icon_43.gif" alt="alarm logo" />
                  </span>
                  <span>预警</span>
                </router-link>
              </h3>
              <div class="alarm-content">
                <ul v-if="hasAlarm" id="alarm-banner">
                  <li v-for="item in alarmContent" :key="item.warning_id">{{item.info}}</li>
                </ul>
                <p v-if="!hasAlarm">
                  <svg class="icon" aria-hidden="true">
                    <use xlink:href="#icon-tishi" />
                  </svg>
                  <span>当前无报警信息!</span>
                </p>
              </div>
            </div>
            <div class="block-data border-img">
              <img src="../../assets/img/index/left_line.png" alt="border-l" />
              <img src="../../assets/img/index/right_line.png" alt="border-r" />
              <ul class="data-content">
                <li v-for="(item,index) in ChildSys_Params" :key="index">
                  <table class="table-p">
                    <thead>
                      <tr>
                        <td colspan="2">{{item.cs_name}}</td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(i,j) in item.cs_data" :key="j">
                        <td>{{i.params_name}}</td>
                        <td>{{i.params_val}}</td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="below-con">
      <el-row :gutter="12">
        <el-col :span="8">
          <div class="grid-content-cooling border-img">
            <img src="../../assets/img/index/left_line.png" alt="border-l" />
            <img src="../../assets/img/index/right_line.png" alt="border-r" />
            <h4>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-icon15" />
              </svg>制冷系统
            </h4>
            <div id="cooling-chart"></div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content-heating border-img">
            <img src="../../assets/img/index/left_line.png" alt="border-l" />
            <img src="../../assets/img/index/right_line.png" alt="border-r" />
            <h4>
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-retu" />
              </svg>供热系统
            </h4>
            <div id="heating-chart"></div>
          </div>
        </el-col>
        <el-col :span="8">
          <div class="grid-content-algorithm border-img">
            <img src="../../assets/img/index/left_line.png" alt="border-l" />
            <img src="../../assets/img/index/right_line.png" alt="border-r" />
            <h4>
              <!-- <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-huaban" />
              </svg>系统公告 -->
              楼层热力图
            </h4>
            <div id="wrapper-algorithm" ref="algorithm-box">
              <!--<ul class="item">-->
              <!--</ul>-->
              <!--<p v-for="(value,key) in algorithmArr" :key="key" >#{{value}}</p>-->
              <!-- <p class="sys-notification">{{systemNotification}}</p> -->
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Floors from "@/components/Floors.vue";
import axios from "axios";
import { EncryptData } from "../../assets/js/common/encrypt";
import bus from "../../assets/js/common/bus";
import alarmInfo from "../../assets/js/common/alarmTable";
import { mockSumData } from "../../assets/js/common/mockData.js"

export default {
  axios,
  name: "home",
  data() {
    return {
      // hasAlarm: true,
      weather_error: "",
      sumComsupError: "",
      coolingSysError: "",
      algorithmArr: [],
      //alarm
      page: 1,
      isfinished: "0",
      machineIndex: 0,
      allMachineInfo: {},
      systemNotification:
        "尊敬的各位用户，因本系统部分功能正在升级，带来不便，敬请谅解！有任何问题请联系管理员！",
      show: true,
      params_visible: [true, true, true, true],
      sendedTemInfo: {
        in: "",
        out: ""
      },
      sumComsupData: [],
      coolingSysData: {
        axisData: [],
        value: []
      },
      algorithmData: {
        cooling_capacity: 200 + "吨", //需冷量
        freezer_num: 1, //冷冻机开启台数
        cooling_computed: "27707.1246", //计算冷负荷
        cooling_indicator: "123", //冷负荷指标
        freezer_frequency: 12 + "hz",
        concentration_co2: "",
        PM25: "",
        freshAir_gear: 2, //新风档位
        vav_gear: 1 //vav档位
      },

      timer_status: 0,
      interval: {
        interval_alarm: null,
        interval_algorithm_up: null,
        interval_algorithm_circle: null,
        interval_algorithm_inner: null,
        interval_algorithm_outer: null,
        interval_machine_update: null,
        interval_machine_banner: null,
        interval_machine_params: null,
        interval_algorithm_animation: null,
        interval_1hours: null
      },
      intervalAlarm_info: {
        speed: 1,
        i: 0
      },
      allCharts: {
        myChart_all: "",
        myChart_temHum: "",
        myChart_cooling: "",
        myChart_heating: "",
        myChart_3dbuilding: ""
      },
      floorViewVisible: false,
      weatherInfo_all: {
        weather_24hours: ""
      },
      weather: {
        temperature: "",
        humidity: "",
        air: "",
        level: "",
        tip: ""
      },
      monitor_params: {
        f_1: {},
        f1: {},
        average: {}
      },
      floors: "",
      animate: false,
      alarmContent: [],
      alarmCurrent: [],
      ChildSys_Params: [
        {
          cs_id: 1,
          cs_name: "冷冻机组",
          cs_data: [
            {
              params_id: "1-1",
              params_name: "每小时需冷量(RT)",
              params_val: ""
            },
            {
              params_id: "1-2",
              params_name: "下小时需冷量(RT)",
              params_val: ""
            },
            { params_id: "2-3", params_name: "冷冻机组效率", params_val: "" },
            { params_id: "2-4", params_name: "实时能耗(kw.h)", params_val: "" },
            {
              params_id: "2-5",
              params_name: "能源运行工况",
              params_val: "制冷"
            }
          ]
        },
        {
          cs_id: 2,
          cs_name: "锅炉",
          cs_data: [
            {
              params_id: "2-1",
              params_name: "每小时需热量(kw.h)",
              params_val: ""
            },
            {
              params_id: "2-2",
              params_name: "下小时需热量(kw.h)",
              params_val: ""
            },
            { params_id: "2-3", params_name: "锅炉机组效率", params_val: "" },
            { params_id: "2-4", params_name: "实时能耗(kw.h)", params_val: "" },
            {
              params_id: "2-5",
              params_name: "能源运行工况",
              params_val: "制热"
            }
          ]
        },
        {
          cs_id: 3,
          cs_name: "新风系统",
          cs_data: [
            {
              params_id: "3-1",
              params_name: "送风PM2.5(μg/m³)",
              params_val: ""
            },
            {
              params_id: "3-2",
              params_name: "回风PM2.5(μg/m³)",
              params_val: ""
            },
            { params_id: "3-3", params_name: "运行数量(台)", params_val: "2" }
          ]
        },
        {
          cs_id: 4,
          cs_name: "vav",
          cs_data: [
            {
              params_id: "4-1",
              params_name: "送风PM2.5(μg/m³)",
              params_val: ""
            },
            {
              params_id: "4-2",
              params_name: "回风PM2.5(μg/m³)",
              params_val: ""
            },
            { params_id: "4-3", params_name: "运行数量(台)", params_val: "2" }
          ]
        }
      ],
      algorithmRecords: []
    };
  },
  beforeCreate: function() {},
  created: function() {
    
    // 请求数据变为自定义数据
    this.sumComsupData = mockSumData();
console.log(this.sumComsupData);
    this.getWeather();
    // this.sumComsuption(); // 获取总能耗数据
    this.sumComsupError = 0; // 渲染总表格

    this.coolingSysElec();
    this.getSysInfo();
  },
  beforeMount: function() {
    this.childSysParams();
  },
  mounted: function() {
    let _this = this;
    this.getIndoorParams();
    this.alarmBanner();
    this.coolingChart();
    // this.algorithmRecord();
    window.onresize = function() {
      _this.allCharts.myChart_all.resize();
      _this.allCharts.myChart_temHum.resize();
      _this.allCharts.myChart_cooling.resize();
      _this.allCharts.myChart_heating.resize();
      _this.allCharts.myChart_3dbuilding.resize();
    };
    //实时获取
    // this.intervalFun(_this.getIndoorParams, 5*1000);
    this.interval.interval_1hours = setInterval(function() {
      _this.getWeather();
      _this.getIndoorParams();
      _this.getSysInfo();
      _this.alarmBanner();
      // _this.sumComsuption(); 
    }, 3600000);
    this.heatingChart();
    // 3D视图
    this.renderCityHomeBuilding();
  },
  beforeUpdate: function() {},
  beforeDestroy: function() {
    this.clearTimer();
  },
  activated: function() {
    //内容刷新(针对keep-alive存在的情况下)
    // this.algorithmRecord();
  },
  methods: {
    //总能耗表
    totalCharts() {
      const _this = this;
      let option,
        axisData = [],
        values = [];
      let chartCon = document.getElementById("total-chart");
      this.allCharts.myChart_all = this.$echarts.init(chartCon);
      if (this.sumComsupError !== "") {
        _this.sumComsupData.forEach(item => {
          let ItemValue =
            item.elect_value > 10000
              ? parseInt(item.elect_value.slice(0, 5)) / 10
              : parseInt(item.elect_value);
          values.push(ItemValue);

          axisData.push(item.date);

          // axisData.push(item.update_time.slice(-8, -3)); //取时分
        });
      }
      //for_show: 代替后台传的时分，用月份代替
      // axisData = ['12','01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11']

      axisData.length > 12 ? axisData.shift() : "";
      values.length > 12 ? values.shift() : "";
      option = {
        tooltip: {
          trigger: "axis",
          formatter: "{b0}月{a0}: {c0}",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          }
        },
        toolbox: {
          show: true,
          orient: "horizontal",
          top: -2,
          right: 0,
          itemGap: 13,
          iconStyle: {
            borderColor: "#82c247"
          },
          feature: {
            // dataView: { readOnly: false },
            magicType: { type: ["line", "bar"] },
            // restore: {},
            saveAsImage: {}
          }
        },
        grid: {
          y: 30,
          y2: 6,
          x: 5, //距离X轴左边
          x2: 30, //距离X轴右边
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            interval: 0,
            axisLabel: {
              show: true,
              interval: 0,
              textStyle: {
                color: "#acacac",
                fontSize: 12
              }
            },
            axisPointer: {
              type: "shadow"
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff"
              }
            },
            splitLine: {
              show: false,
              interval: 0,
              lineStyle: {
                color: "rgba(200,200,200,.2)"
              }
            },
            axisTick: {
              show: true,
              interval: 0
            },
            data: axisData
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "能耗",
            color: "#ccc",
            axisLabel: {
              formatter: "{value}wkw.h",
              textStyle: {
                color: "#acacac",
                fontSize: 12
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(200,200,200,.2)"
              }
            },
            axisTick: {
              show: true
            }
          }
        ],
        series: [
          {
            name: "能耗",
            type: "bar",
            data: values,
            itemStyle: {
              normal: {
                color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff9" },
                  { offset: 0.5, color: "#06f" },
                  { offset: 1, color: "#00f" }
                ])
              }
            },
            markPoint: {
              symbolSize: 30,
              data: [
                { type: "max", name: "最大值" },
                { type: "min", name: "最小值" }
              ],
              itemStyle: {
                color: "blue"
              }
            },

            lineStyle: {
              // step:true,
              type: "solid", //线的样式。solid,dashed,
              width: 1,
              color: "#d92ff1"
            }
          }
        ]
      };
      this.allCharts.myChart_all.setOption(option);
    },
    //温湿度表
    temHumChart() {
      const _this = this;
      let option2;
      let chartCon2 = document.getElementById("tem-hum-chart");

      this.allCharts.myChart_temHum = this.$echarts.init(chartCon2);

      let _xaxis = [],
        temData = [],
        humData = [];
      if (this.weather_error !== "") {
        if (_this.weatherInfo_all.weather_24hours !== "") {
          _this.weatherInfo_all.weather_24hours.forEach(i => {
            _xaxis.push(i.hour.toString() + ":00");
            temData.push(i["temperature"].toString());
            humData.push(
              parseFloat(
                i.humidity.substring(0, i.humidity.length - 1)
              ).toString()
            );
          });
        }
      }
      option2 = {
        //全局调色盘，如果
        color: ["blue", "green", "yellow", "red"],
        legend: {
          itemGap: 15,
          top: 5,
          left: 150,
          data: ["温度", "湿度"],
          textStyle: {
            color: "#fff"
          },
          backgroundColor: "rgba(255,255,255,.1)"
        },
        tooltip: {
          trigger: "axis",
          formatter: "{a0}: {c0}℃<br />{a1}: {c1}%",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          }
        },
        grid: {
          y: 50,
          y2: 2,
          x: 15, //距离X轴左边
          x2: 10, //距离X轴右边
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            interval: 0,
            boundaryGap: 0,
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              show: true
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff"
              }
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false,
              interval: 0
            },
            data: _xaxis.length !== 0 ? _xaxis : autoTime()
          }
        ],
        yAxis: [
          {
            type: "value",
            // name: '温度',
            color: "#aaa",
            min: -20,
            max: 101, //60000
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(200,200,200,.2)"
              }
            },
            axisTick: {
              show: false
            },
            boundaryGap: [0.2, 0.2]
          },
          {
            type: "value",
            // name: '湿度',
            color: "#ccc",
            min: -20,
            max: 101, //200
            axisLabel: {
              show: false
            },
            axisLine: {
              show: false
            },
            splitLine: {
              show: false
            },
            axisTick: {
              show: false
            },
            boundaryGap: [0.2, 0.2]
          }
        ],
        series: [
          {
            name: "温度",
            type: "line",
            symbolSize: 1,
            smooth: true,
            data: temData.length !== 0 ? temData : get_tem(),
            lineStyle: {
              step: true,
              type: "solid", //线的样式。dashed,
              width: 2,
              // color:'green',
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                color: "green",
                colorStops: [
                  {
                    offset: 0,
                    color: "blue" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "blue" // 100% 处的颜色
                  }
                ],
                globalCoord: false // 缺省为 false
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "blue"
                  },
                  {
                    offset: 1,
                    color: "#444756"
                  }
                ])
              }
            }
          },
          {
            name: "湿度",
            type: "line",
            symbol: "squire",
            smooth: true,
            symbolSize: 4,
            yAxisIndex: 1,
            data: humData.length !== 0 ? humData : get_hum(),
            lineStyle: {
              step: true,
              type: "solid", //线的样式。dashed,
              width: 2,
              // color:'blue',
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "green" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "green" // 100% 处的颜色
                  }
                ],
                globalCoord: false // 缺省为 false
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "green"
                  },
                  {
                    offset: 1,
                    color: "#6da18f"
                  }
                ])
              }
            }
          }
        ]
      };
      _this.allCharts.myChart_temHum.setOption(option2);

      //横坐标数组
      function autoTime() {
        let weeks = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
        return weeks;
      }

      //初始化数组
      function get_tem() {
        let tem_arr = [];
        for (let i = 0; i < 7; i++) {
          tem_arr.push((Math.random() * 50 - 10).toFixed(0));
        }
        return tem_arr;
      }

      function get_hum() {
        let hum_arr = [];
        for (let i = 0; i < 7; i++) {
          hum_arr.push((Math.random() * 60 + 40).toFixed(0));
        }
        return hum_arr;
      }
    },
    //制冷系统表
    coolingChart() {
      let _this = this;
      let option;
      let chartCon1 = document.getElementById("cooling-chart");
      let c_values = [],
        c_axis = [];
      if (_this.coolingSysError !== "") {
        _this.coolingSysData.forEach(item => {
          for (var key in item.data) {
            c_values.push(Math.floor(item.data[key] /1000));
            switch (key) {
              case "dn-118":
                c_axis.push("chiller-2");
                break;
              case "dn-81":
                c_axis.push("chiller-1");
                break;
              case "dn-12":
                c_axis.push("chiller-3");
                break;
              case "dn-125":
                c_axis.push("chiller-4");
                break;
              default:
                break;
            }
          }
        });
      }
      this.allCharts.myChart_cooling = this.$echarts.init(chartCon1);

      option = {
        //全局调色盘，如果
        color: ["darkblue", "red", "yellow", "green"],
        legend: {
          itemGap: 15,
          top: 5,
          left: "45%",
          data: ["耗电量/天"],
          textStyle: {
            color: "#fff"
          },
          backgroundColor: "rgba(255,255,255,.2)"
        },
        tooltip: {
          trigger: "axis",
          formatter: "{a0}: {c0}kw.h",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          }
        },
        grid: {
          y: 50,
          y2: 2,
          x: 15, //距离X轴左边
          x2: 10, //距离X轴右边
          containLabel: true
        },
        xAxis: [
          {
            interval: 0,
            boundaryGap: 5,
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              textStyle: {
                color: "#acacac",
                fontSize: 12
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff"
              }
            },
            splitLine: {
              // show:true,
              interval: 0,
              lineStyle: {
                color: "rgba(200,200,200,.2)"
              }
            },
            axisTick: {
              show: true,
              interval: 0
            },
            data: c_axis
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "耗电量/天",
            color: "#ccc",
            axisLabel: {
              formatter: "{value}kw.h",
              textStyle: {
                color: "#acacac",
                fontSize: 12
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(200,200,200,.2)"
              }
            },
            axisTick: {
              show: true
            }
          }
        ],
        series: [
          {
            name: "耗电量/天",
            type: "bar",
            data: c_values,
            itemStyle: {
              normal: {
                color: new _this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  { offset: 0, color: "#83bff9" },
                  { offset: 0.5, color: "#06f" },
                  { offset: 1, color: "#00f" }
                ])
              }
            },
            markPoint: {
              symbolSize: 30,
              data: [{ type: "min", name: "最小值" }],
              itemStyle: {
                color: "darkblue"
              }
            }
          }
        ]
      };
      this.allCharts.myChart_cooling.setOption(option);
    },
    //供热系统表
    heatingChart() {
      let _this = this;
      let option;
      let chartCon2 = document.getElementById("heating-chart");

      this.allCharts.myChart_heating = this.$echarts.init(chartCon2);
      option = {
        //全局调色盘，如果
        color: ["darkgreen", "blue", "yellow", "red"],
        legend: {
          itemGap: 15,
          top: 5,
          left: "45%",
          data: ["气"],
          textStyle: {
            color: "#fff"
          },
          backgroundColor: "rgba(255,255,255,.2)"
        },
        tooltip: {
          trigger: "axis",
          formatter: "{a0}: {c0}立方",
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#283b56"
            }
          }
        },
        grid: {
          y: 50,
          y2: 2,
          x: 15, //距离X轴左边
          x2: 10, //距离X轴右边
          containLabel: true
        },
        xAxis: [
          {
            type: "category",
            interval: 0,
            boundaryGap: 0,
            axisPointer: {
              type: "shadow"
            },
            axisLabel: {
              rotate: 20,
              textStyle: {
                color: "#acacac",
                fontSize: 12
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff"
              }
            },
            splitLine: {
              interval: 0,
              lineStyle: {
                color: "rgba(200,200,200,.2)"
              }
            },
            axisTick: {
              show: true,
              interval: 0
            },
            data: autoTime()
          }
        ],
        yAxis: [
          {
            type: "value",
            name: "气",
            color: "#ccc",
            min: 0,
            max: 100, //200
            axisLabel: {
              formatter: "{value}立方", //{value}万度
              textStyle: {
                color: "green",
                fontSize: 12
              }
            },
            axisLine: {
              show: true,
              lineStyle: {
                color: "#fff"
              }
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: "rgba(200,200,200,.2)"
              }
            },
            axisTick: {
              show: true
            },
            boundaryGap: [0.2, 0.2]
          }
        ],
        series: [
          {
            name: "气",
            type: "line",
            symbol: "diamond",
            smooth: true,
            symbolSize: 8,
            // yAxisIndex: 1,
            data: get_gas(),

            markPoint: {
              symbolSize: 30,
              data: [{ type: "max", name: "最大值" }],
              itemStyle: {
                // color:'blue',
              }
            },
            areaStyle: {
              normal: {
                color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "green"
                  },
                  {
                    offset: 1,
                    color: "#6da18f"
                  }
                ])
              }
            },
            lineStyle: {
              step: true,
              type: "solid", //线的样式。dashed,
              width: 2,
              // color:'blue',
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "green" // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "green" // 100% 处的颜色
                  }
                ],
                globalCoord: false // 缺省为 false
              }
            }
          }
        ]
      };
      this.allCharts.myChart_heating.setOption(option);
      // let getwater = parseFloat(get_water()[23]);
      let getgas = parseFloat(get_gas()[23]);
      setInterval(function() {
        // k += 1;
        let axisData = new Date().getHours() + ":00";

        let data0 = option.series[0].data;

        if (
          22 < parseInt(axisData.substring(0, 2)) ||
          parseInt(axisData.substring(0, 2)) < 7
        ) {
          getgas = parseInt(Math.random() * 30 + 30);
        } else {
          getgas = parseInt(Math.random() * 30 + 57);
        }
        data0.shift();
        data0.push(getgas.toFixed(2));

        option.xAxis[0].data.shift();
        option.xAxis[0].data.push(axisData);

        _this.allCharts.myChart_heating.setOption(option);
      }, 3600000);

      //横坐标数组
      function autoTime() {
        let now = new Date();
        let res = [];
        let len = 24;
        let hours = now.getHours();
        while (len--) {
          res.unshift(hours + ":00");
          if (hours <= 1) {
            hours += 24;
          }
          hours--;
        }
        return res;
      }

      //初始化数组
      function get_water() {
        let start_water = [];
        let time_arr = autoTime();
        for (let i = 0; i < 24; i++) {
          if (
            22 < parseInt(time_arr[i].substring(0, 2)) ||
            parseInt(time_arr[i].substring(0, 2)) < 7
          ) {
            start_water.push(parseFloat(Math.random() * 6 + 6).toFixed(1));
          } else {
            start_water.push(parseFloat(Math.random() * 10 + 16).toFixed(1));
          }
        }
        return start_water;
      }

      function get_gas() {
        let start_gas = [];
        let time_arr = autoTime();
        for (let i = 0; i < 24; i++) {
          if (
            22 < parseInt(time_arr[i].substring(0, 2)) ||
            parseInt(time_arr[i].substring(0, 2)) < 7
          ) {
            start_gas.push(parseFloat(Math.random() * 30 + 20).toFixed(1));
          } else {
            start_gas.push(parseFloat(Math.random() * 30 + 47).toFixed(1));
          }
        }
        return start_gas;
      }
    },
    //楼层点击函数
    showFloor(val) {
      this.floorViewVisible = true;
      this.floors = val;
    },
    //警告信息轮播
    alarmBanner() {
      const _this = this;
      let speed = 1,
        i = 0;
      let encryptData;
      let oBanner = document.querySelector(".alarm-content");
      encryptData = EncryptData({
        page: this.page,
        finish: this.isfinished
      });
      getalarmdata();

      function getalarmdata() {
        clearInterval(_this.interval.interval_alarm);
        if (_this.$store.state.alarm_Info.info) {
          dealData(_this.$store.state.alarm_Info.info);
        } else {
          _this.$api.alarmInfo.obtainAlarm(EncryptData({})).then(res => {
            let resData = {};
            if (res.data.flag === 1) {
              _this.alarmContent = [];
              if (res.data.data.data[0].cold_param.hasOwnProperty("points")) {
                resData = Object.assign(
                  {},
                  res.data.data.data[0].cold_param.points
                );
              } else {
                resData = Object.assign(
                  {},
                  {
                    A2: 1,
                    A3: 1,
                    A4: 1,
                    A48: 1,
                    A49: 1,
                    A50: 1,
                    A8: 1,
                    A9: 1,
                    A10: 1,
                    A11: 1,
                    A12: 1,
                    A159: 1,
                    A160: 1,
                    A182: 1,
                    A217: 1,
                    A246: 1,
                    A247: 1,
                    A248: 1
                  }
                );
              }
              dealData(resData);
            }
          });
        }
      }
      function banner() {
        let oUl = document.getElementById("alarm-banner");
        _this.animate = false;
        let first_child = oUl.children ? oUl.children[0] : "";
        i -= speed;
        if (Math.abs(i) > oUl.children[0].offsetHeight) {
          oUl.removeChild(oUl.children[0]);
          oUl.appendChild(first_child);
          i += oUl.children[0].offsetHeight;
        }
        oUl.children[0].style.marginTop = i + "px";
        oUl.children[oUl.children.length - 1].style.marginTop = 0;
      }

      function dealData(resData) {
        for (let props in resData) {
          if (resData[props] == 1) {
            _this.alarmContent.push({
              equipment_name: props,
              info: alarmInfo[props],
              level: 1
            });
          }
        }
        _this.$store.commit({
          type: "getalarmInfo",
          data: _this.alarmData
        });
        if (_this.alarmContent[0]) {
          _this.interval.interval_alarm = setInterval(banner, 150);
        }
        if (_this.timer_status) {
          clearInterval(_this.interval.interval_alarm);
        }
        if (oBanner === null || !oBanner) {
          clearInterval(_this.interval.interval_alarm);
        }
        oBanner.onmouseover = function() {
          clearInterval(_this.interval.interval_alarm);
        };
        oBanner.onmouseout = function() {
          _this.interval.interval_alarm = setInterval(banner, 150);
        };
        _this.loading = false;
      }
      i = 0;
    },
    //锅炉、新风、vav、冷冻机的数据展示
    childSysParams() {
      let _this = this;
      this.ChildSys_Params[0].cs_data[0].params_val = (
        Math.random() * 80 +
        200
      ).toFixed(1);
      this.ChildSys_Params[0].cs_data[1].params_val = (
        Math.random() * 80 +
        200
      ).toFixed(1);
      this.ChildSys_Params[0].cs_data[2].params_val = (
        Math.random() * 0.9 +
        3
      ).toFixed(1);
      this.ChildSys_Params[0].cs_data[3].params_val = (
        Math.random() * 8.5 +
        76.5
      ).toFixed(1);

      this.ChildSys_Params[1].cs_data[0].params_val = (
        Math.random() * 80 +
        200
      ).toFixed(1);
      this.ChildSys_Params[1].cs_data[1].params_val = (
        Math.random() * 80 +
        200
      ).toFixed(1);
      this.ChildSys_Params[1].cs_data[2].params_val = (
        Math.random() * 0.9 +
        3
      ).toFixed(1);
      this.ChildSys_Params[1].cs_data[3].params_val = (
        Math.random() * 8.5 +
        76.5
      ).toFixed(1);

      this.ChildSys_Params[1].cs_data[0].params_val = (
        Math.random() * 45 +
        30
      ).toFixed(1); //新风的送风、回风pm2.5
      this.ChildSys_Params[1].cs_data[1].params_val = (
        Math.random() * 45 +
        30
      ).toFixed(1);

      this.ChildSys_Params[2].cs_data[0].params_val = (
        Math.random() * 45 +
        30
      ).toFixed(1);
      this.ChildSys_Params[2].cs_data[1].params_val = (
        Math.random() * 45 +
        30
      ).toFixed(1);

      this.ChildSys_Params[3].cs_data[0].params_val = (
        Math.random() * 45 +
        30
      ).toFixed(1);
      this.ChildSys_Params[3].cs_data[1].params_val = (
        Math.random() * 45 +
        30
      ).toFixed(1);

      // function assignment(min, max, item, index) {
      //   let difference = max - min;
      //   setInterval(function() {
      //     _this.ChildSys_Params[item].cs_data[index].params_val =
      //       parseFloat((Math.random() * difference).toFixed(1)) + min;
      //   }, 5000);
      // }

      // assignment(200, 280, 0, 0);
      // assignment(200, 280, 0, 1);
      // assignment(3, 4, 0, 2);
      // assignment(76.5, 85, 0, 3);
      // assignment(200, 280, 1, 0);
      // assignment(200, 280, 1, 1);
      // assignment(3, 4, 1, 2);
      // assignment(76.5, 85, 1, 3);
      // assignment(30, 75, 1, 0);
      // assignment(30, 75, 1, 1);

      // assignment(30, 75, 2, 0);
      // assignment(30, 75, 2, 1);

      // assignment(30, 75, 3, 0);
      // assignment(30, 75, 3, 1);
    },
    //轮播

    getWeather() {
      let _this = this;
      this.$api.weather
        .getWeather(EncryptData({}))
        .then(res => {
          //如果此处有错误，会进入catch
          _this.weather_error = 0;

          Object.assign(_this.weatherInfo_all, res.data.data);
          Object.assign(_this.weather, res.data.data.weather_current);
          _this.sendedTemInfo.out = _this.weather.temperature;
          Object.assign(_this.monitor_params, res.data.data.weather_current);
          _this.monitor_params.humidity = _this.monitor_params.humidity.slice(
            3
          );
          delete _this.monitor_params.alert_info;

          _this.algorithmData.outer_tem =
            _this.monitor_params.temperature || "";
        })
        .catch(error => {
          _this.weather_error = 1;
        });
    },
    getIndoorParams() {
      const _this = this;
      _this.$api.systemInfo
        .indoor_params(EncryptData({}))
        .then(res => {
          if (res.data.flag == 1) {
            average(res.data.data[0], res.data.data[1]);
            _this.monitor_params.f_1 = Object.assign({}, res.data.data[0]);
            _this.monitor_params.f1 = Object.assign({}, res.data.data[1]);
          }
        })
        .catch(() => {});
      function average(a, b) {
        _this.monitor_params.average.temperature = (
          (a.temperature + b.temperature) /
          2
        ).toFixed(1);
        _this.sendedTemInfo.in = _this.monitor_params.average.temperature;
        _this.monitor_params.average.humidity = (
          (a.humidity + b.humidity) /
          2
        ).toFixed(1);
        _this.monitor_params.average.co2 = ((a.co2 + b.co2) / 2).toFixed(1);
        _this.monitor_params.average.pm25 = ((a.pm25 + b.pm25) / 2).toFixed(1);
        for (let key in a) {
          if (!a[key])
            _this.monitor_params.average[key] = b[key] ? b[key] : "?";
        }
        for (let key1 in b) {
          if (!b[key1])
            _this.monitor_params.average[key1] = a[key1] ? a[key1] : "?";
        }
      }
    },
    getSysInfo() {
      const _this = this;
      //更改冷冻机组需冷量为模拟数据
      // obtainSysInfo();
      function obtainSysInfo() {
        _this.$api.systemInfo.machine_info(EncryptData({})).then(res => {
          if (res.data.flag === 1) {
            _this.ChildSys_Params[0].cs_data[0].params_val =
              res.data.data.chiller_data.chilling;
            _this.ChildSys_Params[0].cs_data[1].params_val =
              res.data.data.chiller_data.next_chilling;

            _this.ChildSys_Params[1].cs_data[0].params_val =
              res.data.data.vav_data[0].supply_air_temp;
            _this.ChildSys_Params[1].cs_data[1].params_val =
              res.data.data.vav_data[0].back_air_temp;
          }
        });
      }
    },
    sumComsuption() {
      const _this = this;
      this.$api.systemInfo.SumEelec(EncryptData({})).then(res => {
        if (res.data.flag === 1) {
          _this.sumComsupData = res.data.data;
          _this.sumComsupError = 0;
        }
      });
    },
    coolingSysElec() {
      const _this = this;
      this.$api.systemInfo.coolingSysElec(EncryptData({})).then(res => {
        if (res.data.flag === 1) {
          _this.coolingSysData = res.data.data;
          _this.coolingSysError = 0;
        }
      });
    },
    clearTimer() {
      const _this = this;
      _this.timer_status = 1;
      clearInterval(_this.interval.interval_alarm);
      clearInterval(_this.interval.interval_algorithm_animation);
      clearInterval(_this.interval.interval_machine_params);
      clearInterval(_this.interval.interval_1hours);
    },
    renderCityHomeBuilding() {
      const chartDom = document.querySelector("#wrapper-algorithm");
      this.myChart_3dbuilding = this.$echarts.init(chartDom);
      const hours = [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15"
      ];
      const days = [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "10",
        "11",
        "12",
        "13",
        "14",
        "15",
        "16"
      ];

      const data = [
        [0, 0, 3],
        [0, 1, 9],
        [0, 2, 9],
        [0, 3, 9],
        [0, 4, 9],
        [0, 5, 8.8],
        [0, 6, 8.6],
        [0, 7, 8.4],
        [0, 8, 8.2],
        [0, 9, 8],
        [0, 10, 7.8],
        [0, 11, 7.6],
        [0, 12, 7.5],
        [0, 13, 7.5],
        [0, 14, 7.5],
        [0, 15, 7.5],

        [1, 0, 3],
        [1, 1, 9],
        [1, 2, 9],
        [1, 3, 9],
        [1, 4, 9],
        [1, 5, 8.8],
        [1, 6, 8.6],
        [1, 7, 8.4],
        [1, 8, 8.2],
        [1, 9, 8],
        [1, 10, 7.8],
        [1, 11, 7.6],
        [1, 12, 7.5],
        [1, 13, 7.5],
        [1, 14, 7.5],
        [1, 15, 7.5],

        [2, 0, 3],
        [2, 1, 9],
        [2, 2, 9],
        [2, 3, 9],
        [2, 4, 9],
        [2, 5, 8.8],
        [2, 6, 8.6],
        [2, 7, 8.4],
        [2, 8, 8.2],
        [2, 9, 8],
        [2, 10, 7.8],
        [2, 11, 7.6],
        [2, 12, 7.5],
        [2, 13, 7.5],
        [2, 14, 7.5],
        [2, 15, 7.5],

        [3, 0, 3],
        [3, 1, 9],
        [3, 2, 9],
        [3, 3, 9],
        [3, 4, 9],
        [3, 5, 8.8],
        [3, 6, 8.6],
        [3, 7, 8.4],
        [3, 8, 8.2],
        [3, 9, 8],
        [3, 10, 7.8],
        [3, 11, 7.6],
        [3, 12, 7.5],
        [3, 13, 7.5],
        [3, 14, 7.5],
        [3, 15, 7.5],

        [4, 0, 0],
        [4, 1, 9],
        [4, 2, 9],
        [4, 3, 9],
        [4, 4, 9],
        [4, 5, 0],
        [4, 6, 0],
        [4, 7, 0],
        [4, 8, 0],
        [4, 9, 0],
        [4, 10, 0],
        [4, 11, 0],
        [4, 12, 7.3],
        [4, 13, 7.3],
        [4, 14, 7.3],
        [4, 15, 7.3],

        [5, 0, 0],
        [5, 1, 9],
        [5, 2, 9],
        [5, 3, 9],
        [5, 4, 9],
        [5, 5, 0],
        [5, 6, 0],
        [5, 7, 0],
        [5, 8, 0],
        [5, 9, 0],
        [5, 10, 0],
        [5, 11, 0],
        [5, 12, 7.1],
        [5, 13, 7.1],
        [5, 14, 7.1],
        [5, 15, 7.1],

        [6, 0, 0],
        [6, 1, 9],
        [6, 2, 9],
        [6, 3, 9],
        [6, 4, 9],
        [6, 5, 0],
        [6, 6, 0],
        [6, 7, 0],
        [6, 8, 0],
        [6, 9, 0],
        [6, 10, 0],
        [6, 11, 0],
        [6, 12, 6.9],
        [6, 13, 6.9],
        [6, 14, 6.9],
        [6, 15, 6.9],

        [7, 0, 0],
        [7, 1, 9],
        [7, 2, 9],
        [7, 3, 9],
        [7, 4, 9],
        [7, 5, 0],
        [7, 6, 0],
        [7, 7, 0],
        [7, 8, 0],
        [7, 9, 0],
        [7, 10, 0],
        [7, 11, 0],
        [7, 12, 6.7],
        [7, 13, 6.7],
        [7, 14, 6.7],
        [7, 15, 6.7],

        [8, 0, 0],
        [8, 1, 9],
        [8, 2, 9],
        [8, 3, 9],
        [8, 4, 9],
        [8, 5, 0],
        [8, 6, 0],
        [8, 7, 0],
        [8, 8, 0],
        [8, 9, 0],
        [8, 10, 0],
        [8, 11, 0],
        [8, 12, 6.5],
        [8, 13, 6.5],
        [8, 14, 6.5],
        [8, 15, 6.5],

        [9, 0, 0],
        [9, 1, 9],
        [9, 2, 9],
        [9, 3, 9],
        [9, 4, 9],
        [9, 5, 0],
        [9, 6, 0],
        [9, 7, 0],
        [9, 8, 0],
        [9, 9, 0],
        [9, 10, 0],
        [9, 11, 0],
        [9, 12, 6.3],
        [9, 13, 6.3],
        [9, 14, 6.3],
        [9, 15, 6.3],

        [10, 0, 0],
        [10, 1, 9],
        [10, 2, 9],
        [10, 3, 9],
        [10, 4, 9],
        [10, 5, 0],
        [10, 6, 0],
        [10, 7, 0],
        [10, 8, 0],
        [10, 9, 0],
        [10, 10, 0],
        [10, 11, 0],
        [10, 12, 6.1],
        [10, 13, 6.1],
        [10, 14, 6.1],
        [10, 15, 6.1],

        [11, 0, 0],
        [11, 1, 9],
        [11, 2, 9],
        [11, 3, 9],
        [11, 4, 9],
        [11, 5, 4.6],
        [11, 6, 4.8],
        [11, 7, 5],
        [11, 8, 5.2],
        [11, 9, 5.4],
        [11, 10, 5.6],
        [11, 11, 5.8],
        [11, 12, 6],
        [11, 13, 6],
        [11, 14, 6],
        [11, 15, 6],

        [12, 0, 0],
        [12, 1, 9],
        [12, 2, 9],
        [12, 3, 9],
        [12, 4, 9],
        [12, 5, 4.6],
        [12, 6, 4.8],
        [12, 7, 5],
        [12, 8, 5.2],
        [12, 9, 5.4],
        [12, 10, 5.6],
        [12, 11, 5.8],
        [12, 12, 6],
        [12, 13, 6],
        [12, 14, 6],
        [12, 15, 6],

        [13, 0, 0],
        [13, 1, 9],
        [13, 2, 9],
        [13, 3, 9],
        [13, 4, 9],
        [13, 5, 4.6],
        [13, 6, 4.8],
        [13, 7, 5],
        [13, 8, 5.2],
        [13, 9, 5.4],
        [13, 10, 5.6],
        [13, 11, 5.8],
        [13, 12, 6],
        [13, 13, 6],
        [13, 14, 6],
        [13, 15, 6],

        [14, 0, 0],
        [14, 1, 4.3],
        [14, 2, 4.4],
        [14, 3, 4.5],
        [14, 4, 4.5],
        [14, 5, 4.6],
        [14, 6, 4.8],
        [14, 7, 5],
        [14, 8, 5.2],
        [14, 9, 5.4],
        [14, 10, 5.6],
        [14, 11, 5.8],
        [14, 12, 6],
        [14, 13, 6],
        [14, 14, 6],
        [14, 15, 6]
      ];
      const option_3d = {
        // tooltip: {},
        visualMap: {
          bottom: 10,
          left: 20,
          max: 20,
          inRange: {
            color: [
              "#FF6699",
              "#FF6669",
              "#FF6663",
              "#FF6633",
              "#FF6630",
              "#FF6600",
              "#FF6300",
              "#FF3303",
              "#FF3300",
              "#FF3033",
              "#FF0033"
            ]
          }
        },
        xAxis3D: {
          show: false,
          name: "",
          type: "category",
          data: hours
        },
        yAxis3D: {
          show: false,
          name: "",
          type: "category",
          data: days
        },
        zAxis3D: {
          show: false,
          name: "",
          type: "value"
        },
        grid3D: {
          top: -10,
          left: 30,
          boxWidth: 240, //三维场景宽度！
          boxDepth: 240,
          boxHeight: 120, //三维场景高度！
          height: "100%",
          viewControl: {
            projection: "perspective",
            autoRotate: true,
            autoRotateDirection: "cw", //从上往下看。逆时针方向！
            autoRotateSpeed: 5, //旋转速度，default：10
            autoRotateAfterStill: 4, //鼠标静止操作后恢复自动旋转的时间间隔！
            rotateSensitivity: 2,
            distance: 310
          },
          splitArea: { show: false },
          splitLine: { show: false },
          axisLabel: {
            show: false
          },
          light: {
            //阴影
            main: {
              intensity: 1.2,
              shadow: true
            },
            ambient: {
              intensity: 0.9
            }
          }
        },
        series: [
          {
            type: "bar3D",
            data: data.map(function(item) {
              return {
                value: [item[0], item[1], item[2]]
              };
            }),
            shading: "lambert",

            label: {
              show: false,
              textStyle: {
                fontSize: 16,
                borderWidth: 1
              }
            },

            emphasis: {
              label: {
                textStyle: {
                  fontSize: 20,
                  color: "#900"
                }
              },
              itemStyle: {
                color: "#900"
              }
            }
          }
        ]
      };
      this.myChart_3dbuilding.setOption(option_3d);
    },
    toggleShow(i) {
      const _this = this;
      switch (i) {
        case 0:
          toggle(i);
          break;
        case 1:
          toggle(i);
          break;
        case 2:
          toggle(i);
          break;
        case 3:
          toggle(i);
          break;
        default:
          return;
      }
      function toggle(i) {
        let status = !_this.params_visible[i];
        _this.$set(_this.params_visible, i, status);
      }
    }
  },
  computed: {
    ...mapState(["token", "got_weather"]),
    hasAlarm: function() {
      if (this.alarmContent[0]) return true;
      else {
        clearInterval(this.interval.interval_alarm);
        return false;
      }
    }
  },
  watch: {
    weather_error: function() {
      this.temHumChart();
    },
    sumComsupError: function() {
      this.totalCharts();
    },
    coolingSysError: function() {
      this.coolingChart();
    },
    // algorithmData: {
    //   handler(val, oldval) {
    //     // this.algorithmRecord();
    //   },
    //   deep: true
    // }
  },
  components: {
    floors: Floors
  },
  beforeRouteLeave(to, from, next) {
    next();
  },
  beforeRouteUpdate(to, from, next) {
    next();
  }
};
</script>

<style lang="scss">
@import "../../assets/style/home";
@mixin m1rem {
  margin: 0.1rem !important;
}
@mixin p1rem {
  padding: 0.1rem !important;
}
@mixin mp5rem {
  margin: 0.1rem !important;
  padding: 0.5rem !important;
}
#floor-thermal {
  .el-dialog__wrapper {
    top: -12vh;
    .el-dialog {
      background-color: rgba(200, 200, 200, 0.4);
      .el-dialog__header {
        padding-bottom: 0;
        border-bottom: 1px solid #999;
        .el-dialog__title {
          width: 100%;
          color: #eee;
        }
      }
      .el-dialog__body {
        @include mp5rem;
      }
    }
  }
}
</style>
